import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import ExpenseModel from "../models/ExpenseModel";
import ExpenseQueryModel from "../models/ExpenseQueryModel";
import ExpenseAnalyticsModel from "../models/ExpenseAnalyticsModel";

export interface SearchExpenseParam {
    pageSize: number,
    query: ExpenseQueryModel
}

export interface GetExpenseByIdParam {
    id: string,
}

export interface DeleteExpenseByIdParam {
    id: string,
}

const ExpenseApi = {
    GetExpenseAnalytics() {
        return Api.post<unknown, BaseResponse<ExpenseAnalyticsModel[]>>("/api/Expense/GetExpenseAnalytics", null);
    },
    Save(param: ExpenseModel) {
        return Api.post<ExpenseModel, BaseResponse<ExpenseModel>>("/api/Expense/Save", param);
    },
    GetById(param: GetExpenseByIdParam) {
        return Api.get<GetExpenseByIdParam, BaseResponse<ExpenseModel>>("/api/Expense/GetById", param);
    },
    Delete(param: DeleteExpenseByIdParam) {
        return Api.post<DeleteExpenseByIdParam, BaseResponse<ExpenseModel>>("/api/Expense/Delete", param);
    },
    GetExpenseItems() {
        return Api.get<unknown, BaseResponse<string[]>>("/api/Expense/GetExpenseItems", null);
    },
};
export default ExpenseApi;